import {
	type CountryCode,
	type ValidationResult,
	validatePhoneNumber,
} from "@leabankab/component-library";

/** Mobile subscriber prefixes in E.164; the library cannot reject landlines yet. */
const MOBILE_E164 = {
	SE: /^\+467\d{8}$/,
	FI: /^\+358(4\d|50)\d{7}$/,
} as const;

/** Library owns parsing and E.164 output; the app only rejects landlines. */
export const validateMobileNumber = (
	country: CountryCode,
	value: string
): ValidationResult => {
	const result = validatePhoneNumber(country, value);
	const mobilePattern =
		country === "SE" || country === "FI" ? MOBILE_E164[country] : undefined;

	if (
		mobilePattern &&
		result.normalized &&
		!mobilePattern.test(result.normalized)
	) {
		return { valid: false };
	}

	return result;
};
